import * as React from "react";
import { ComponentServices } from "../ComponentServices";
import { useTimezoneOffset } from "./useTimezoneOffset";
// Move to common/kalep-integration
/**
 * Turn Europe/Tallinn into valid timezone name as Europe, Tallinn (UTC +03:00)
 *
 * @param props
 * @constructor
 */
export function TimezoneFormatter(props) {
  var _React$useContext = React.useContext(ComponentServices.Context),
    timezoneService = _React$useContext.timezoneService;
  var timezoneTitle = React.useMemo(function () {
    var _a;
    return (_a = timezoneService.getTimezones().find(function (t) {
      return t.value === props.value;
    })) === null || _a === void 0 ? void 0 : _a.title;
  }, [timezoneService, props.value]);
  var offsetText = useTimezoneOffset({
    timezone: props.value,
    unix: props.unix
  });
  var timezoneWithOffset = "".concat(timezoneTitle, " (").concat(offsetText, ")");
  // eslint-disable-next-line react/jsx-no-useless-fragment -- just want to return the string, but keep the JSX type.
  return /*#__PURE__*/React.createElement(React.Fragment, null, timezoneWithOffset);
}